import React, { useEffect } from 'react';
import { Row, Col, Card, Image } from 'antd';
import Paragraph from 'antd/es/typography/Paragraph';
import { styles } from './styles';
import { Link } from 'react-router-dom';
import { CATGORY_LINKS, LOGO_URL, PAGE_TITLES } from '../../utils/constant';
import { useMediaQuery } from '../../hooks/MediaQuery.hook';

const gridStyle: React.CSSProperties = {
    width: '25%',
    textAlign: 'center',
};

interface categoryInterface {
    label: string;
    link: string;
}

export default function AboutUs() {
    const matches = useMediaQuery('(min-width: 768px)');

    useEffect(() => {
        document.title = PAGE_TITLES.ABOUT;
    }, []);

    return (
        <Card title='SportsFeed24.cx' style={matches ? { padding: '20px' } : {}}>
            <Row gutter={24} style={styles.logo}>
                <Col span={16} xs={24} sm={12} md={8} lg={6}>
                    <Image width={130} src={LOGO_URL} style={{ background: '#95100d' }} />
                </Col>
            </Row>

            {/* What is SportsFeed24 */}
            <Row gutter={24}>
                <Col span={12} xs={24} sm={12}>
                    <Card title='What is SportsFeed24?' style={styles.card}>
                        <Card.Meta
                            title='SportsFeed24.cx – Your Official Hub for Live Sports Coverage and Streams'
                        />
                        <Paragraph style={styles.paragraph}>
                            SportsFeed24.cx is your go-to platform for real-time sports coverage and
                            streaming updates. Whether it’s Football, NFL, NBA, UFC, Formula 1,
                            Cricket, or Boxing, our site connects fans with live match schedules,
                            updates, and trusted stream sources – all in one place. Enjoy a clean,
                            safe, and fast sports experience built for true fans.
                        </Paragraph>
                    </Card>
                </Col>

                <Col span={12} xs={24} sm={12}>
                    <Card title='What We Provide' style={styles.card}>
                        <Card.Meta
                            title='Live Sports Coverage and Stream Links for Every Major League'
                        />
                        <Paragraph style={styles.paragraph}>
                            At SportsFeed24.cx, we deliver real-time access to sports updates and
                            streaming sources for the world’s biggest leagues and tournaments. From
                            Premier League Football and UFC Fight Nights to NBA Playoffs and Formula
                            1 Grand Prix, everything you love is just a click away. Our mission is
                            to make watching sports simple, reliable, and free for fans worldwide.
                        </Paragraph>
                    </Card>
                </Col>
            </Row>

            {/* How to Use */}
            <Row gutter={24}>
                <Col span={12} xs={24} sm={12}>
                    <Card
                        title='How to Use SportsFeed24.cx for Live Sports'
                        style={styles.card}
                    >
                        <Link className='nav-link' to={'/'}>
                            <span style={styles.paragraph}>
                                Follow these steps to watch your favorite matches:
                            </span>
                        </Link>

                        <p style={styles.paragraph}><strong>Step 1:</strong> Visit SportsFeed24.cx.</p>
                        <p style={styles.paragraph}><strong>Step 2:</strong> Browse the homepage to find live and upcoming matches.</p>
                        <p style={styles.paragraph}><strong>Step 3:</strong> Select your preferred sport (Football, NFL, UFC, etc.).</p>
                        <p style={styles.paragraph}><strong>Step 4:</strong> Click on the event to see available stream links.</p>
                        <p style={styles.paragraph}><strong>Step 5:</strong> Choose a working link and start streaming.</p>
                        <p style={styles.paragraph}><strong>Step 6:</strong> Enjoy uninterrupted HD live sports for free!</p>
                    </Card>
                </Col>

                {/* Sports Categories */}
                <Col span={12} xs={24} sm={12}>
                    <Card
                        title='Which Live Sports Streams Are Available?'
                        style={styles.card}
                    >
                        {CATGORY_LINKS?.map((cat: categoryInterface, index: number) => (
                            <Card.Grid key={index} style={gridStyle}>
                                <Link to={cat.link}>{cat.label}</Link>
                            </Card.Grid>
                        ))}
                    </Card>
                </Col>
            </Row>

            {/* Soccer and UFC */}
            <Row gutter={24}>
                <Col span={12} xs={24} sm={12}>
                    <Card title='Free Live Soccer Streams' style={styles.card}>
                        <Paragraph>
                            SportsFeed24.cx streams every major football event including the English
                            Premier League, Bundesliga, Serie A, Ligue 1, MLS, Saudi Pro League, and
                            La Liga. You can also watch top tournaments such as the UEFA Champions
                            League, Europa League, and FIFA World Cup. For the best Reddit soccer
                            streams and free HD football coverage, visit our homepage.
                        </Paragraph>
                    </Card>
                </Col>

                <Col span={12} xs={24} sm={12}>
                    <Card title='Live UFC Streams and Fight Nights' style={styles.card}>
                        <Paragraph>
                            Watch every major UFC event on SportsFeed24.cx — from UFC Fight Nights
                            and Pay-Per-View cards to ESPN main events. Stay updated with upcoming
                            fight schedules and live match coverage.
                        </Paragraph>
                    </Card>
                </Col>
            </Row>

            {/* Boxing */}
            <Row gutter={24}>
                <Col span={12} xs={24} sm={12}>
                    <Card title='Free Live Boxing Streams' style={styles.card}>
                        <Paragraph>
                            Stream major boxing events from organizations such as WBA, WBC, and IBF
                            in real-time. SportsFeed24 delivers HD-quality boxing streams and
                            live match updates every week.
                        </Paragraph>
                    </Card>
                </Col>
            </Row>

            {/* Detailed Sports List and Why Use SportsFeed24 */}
            <Row gutter={24}>
                <Col span={12} xs={24} sm={12}>
                    <Card title='Sports Categories on SportsFeed24.cx' style={styles.card}>
                        <li className='nav-item'>
                            <Link className='nav-link' to={'/'}>
                                <span>Which Live Sports Does SportsFeed24 Cover?</span>
                            </Link>
                            <p style={styles.paragraph}>
                                Here’s what you can stream on SportsFeed24:
                            </p>

                            <p style={styles.paragraph}><strong>1. Football / Soccer</strong><br />
                                Watch Premier League, La Liga, Serie A, Bundesliga, Ligue 1, MLS, and more. Enjoy UEFA, World Cup, and other top tournaments.
                            </p>

                            <p style={styles.paragraph}><strong>2. UFC</strong><br />
                                Stream UFC 300, Fight Night, and Pay-Per-View events live.
                            </p>

                            <p style={styles.paragraph}><strong>3. Boxing</strong><br />
                                Access top bouts from WBA, WBC, and IBF directly on our platform.
                            </p>

                            <p style={styles.paragraph}><strong>4. NFL</strong><br />
                                Stream live NFL games, playoffs, and the Super Bowl for free.
                            </p>

                            <p style={styles.paragraph}><strong>5. Formula 1</strong><br />
                                Watch live Formula 1 races and the full World Championship season.
                            </p>

                            <p style={styles.paragraph}><strong>6. Cricket</strong><br />
                                Catch T20, ODI, and Test matches from around the world.
                            </p>

                            <p style={styles.paragraph}><strong>7. NBA</strong><br />
                                Stream regular season and playoff NBA games in HD quality.
                            </p>
                        </li>
                    </Card>
                </Col>

                <Col span={12} xs={24} sm={12}>
                    <Card title='Why Choose SportsFeed24.cx?' style={styles.card}>
                        <p style={styles.paragraph}>
                            SportsFeed24.cx offers fans a safe, fast, and high-quality sports
                            streaming experience. No sign-ups, no fees — just pure sports.
                        </p>
                        <p style={styles.paragraph}>
                            ✅ 100% Free live sports streams  
                            ✅ Safe and secure browsing  
                            ✅ HD-quality coverage for all major sports  
                            ✅ Updated daily with new links and schedules  
                            ✅ Trusted source for Reddit soccer streams and live NFL coverage
                        </p>
                        <p style={styles.paragraph}>
                            Join millions of fans who choose SportsFeed24.cx as their official home
                            for global sports coverage.
                        </p>
                    </Card>
                </Col>
            </Row>
        </Card>
    );
};